export default __webpack_public_path__ + "static/66e6e5d244923d4c4d458a80a8d130e8.png";